import CryptoJS from 'crypto-js'

// 默认自定义的约定密钥(与后端密钥保持一致)
// 密钥16位长度字符   内容可自定义
//  密钥偏移量    16位长度字符

const AES = {
  encrypt (str, keyStr, ivStr) {
    const key = CryptoJS.enc.Utf8.parse(keyStr)
    const iv = CryptoJS.enc.Utf8.parse(ivStr)
    // 明文
    const srcs = CryptoJS.enc.Utf8.parse(str)
    // 加密
    const encrypt = CryptoJS.AES.encrypt(srcs, key, {
      iv: iv,
      mode: CryptoJS.mode.CBC, // AES加密模式
      padding: CryptoJS.pad.Pkcs7 // 填充方式
    })
    // 返回base64格式密文
    return CryptoJS.enc.Base64.stringify(encrypt.ciphertext)
  },
  decrypt (str, keyStr, ivStr) {
    const key = CryptoJS.enc.Utf8.parse(keyStr)
    const iv = CryptoJS.enc.Utf8.parse(ivStr)
    // base64格式密文转换
    const base64 = CryptoJS.enc.Base64.parse(str)
    const src = CryptoJS.enc.Base64.stringify(base64)
    // 解密
    const decrypt = CryptoJS.AES.decrypt(src, key, {
      iv: iv,
      mode: CryptoJS.mode.CBC, // AES加密模式
      padding: CryptoJS.pad.Pkcs7 // 填充方式
    })
    // 返回明文
    return CryptoJS.enc.Utf8.stringify(decrypt).toString()
  }
}
export default AES
